import { render, staticRenderFns } from "./TermsConsentimento.vue?vue&type=template&id=1d1d4854&scoped=true"
import script from "./TermsConsentimento.vue?vue&type=script&lang=js"
export * from "./TermsConsentimento.vue?vue&type=script&lang=js"
import style0 from "./TermsConsentimento.vue?vue&type=style&index=0&id=1d1d4854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1d4854",
  null
  
)

export default component.exports